(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/svs-logo.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/svs-logo.js');

'use strict';

const Brand = svs.ui.ReactBrand;
const SvsLogo = () => {
  const theme = ReactRedux.useSelector(state => state.playerloginreact.theme);
  return React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement(Brand, {
    brand: "svenskaspel-twolines".concat(theme.isInverted ? '-neg' : ''),
    emblem: true
  }), React.createElement("p", null, "Spel fr\xE5n AB Svenska Spel"), React.createElement("p", null, "Spel f\xF6r dig \xF6ver 18 \xE5r | St\xF6dlinjen:", ' ', React.createElement("span", {
    className: "login-react-hover"
  }, React.createElement("a", {
    className: theme.fontColor,
    href: "tel:020-819100"
  }, "020 81 91 00"))));
};
svs.playerLoginReact.sharedComponents.SvsLogo = SvsLogo;

 })(window);